import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-document-facture',
  templateUrl: './document-facture.component.html',
  styleUrls: ['./document-facture.component.scss']
})
export class DocumentFactureComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
